import { styled, Box, Button, Typography, Grid, Dialog, Pagination } from "@mui/material";
import Link from "@mui/material/Link";
import MenuItem from "@mui/material/MenuItem";

/* common font style start */

export const AppContentWrapper = styled(Box)(
  () =>
    `
    width:100%;
    overflow:auto;
    padding:0px;
    ::-webkit-scrollbar-thumb {
      background-color: rgba(155, 155, 155, 0.5);
      border-radius: 20px;
      border: transparent;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar {
      width: 3px;
    }
    `
);

export const PopinsThirtySixText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "36px",
}));

export const PopinsEighteenText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "18px",
}));

export const PopinsElevenText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "11px",
}));

export const PopinsTwelveText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
}));

export const PopinsTwelveTextBox = styled(Box)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
}));

export const PopinsTwelveBox = styled(Box)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
}));

export const PopinsTwelveBtnText = styled(Button)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
}));

export const PopinsSmallText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
}));

export const PopinsThirteenMenuItem = styled(MenuItem)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "13px",
}));

export const PopinsThirteenTypography = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "max(13px, 0.8vw)",
}));

export const PopinsForteenText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
}));

export const PopinsForteen = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "14px",
}));

export const PopinsForteenTextBtn = styled(Button)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
}));

export const PopinsFifteenTextBtn = styled(Button)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "15px",
}));

export const PopinsFifteenText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "15px",
}));

export const PoppinsTwentyText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "20px",
}));

export const PoppinsTwenty = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "20px",
}));

export const PopinsTwentyFourText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "24px",
}));

export const PopinsTenText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "10px",
}));

export const WaitingText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
}));

export const PopinsSmallInstantText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "11px",
  marginTop: "6px",
}));

export const PopinsTenPixelText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "0.76vw",
}));

export const PopinsSixteenText = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
  color: "#3087EC",
}));

export const PopinsSixteenTypography = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
}));

export const PopinsSixteenTxtSmallBold = styled(Typography)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "16px",
}));

/* common font style end */

/* common dispaly flex style start */
export const DisplayFlex = styled(Box)(() => ({
  display: "flex",
}));

export const DisplayGridFlex = styled(Grid)(() => ({
  display: "flex",
}));

export const DisplayFlexCenter = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const DisplayFlexAlignSelfCenter = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  alignSelf: "center",
}));

export const DisplayFlexJustifyCenter = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
}));

export const DisplayFlexAlignCenter = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

export const DisplayFlexGrid = styled(Grid)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const DisplayFlexStartBox = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
}));

export const DisplayFlexStartGrid = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
}));

export const DisplayFlexStart = styled(Grid)(() => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
}));

export const DisplayBoxFlexEnd = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-end",
  alignContent: "flex-end",
  justifyContent: "flex-end",
}));

export const DisplayJustifyFlexStart = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
}));

export const DisplayJustifyFlexEnd = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
}));

export const DisplayFlexSpaceBetween = styled(Box)(() => ({
  display: "flex",
  alignItems: "space-between",
  justifyContent: "space-between",
}));

export const DisplayFlexColumn = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const DisplayFlexGridColumn = styled(Grid)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const DisplayFlexTypographyColumn = styled(Typography)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

export const DisplayFlexRow = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
}));

export const DisplayFlexJustifyDirection = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  flexDirection:"row"
}));

export const DisplayFlexRowDirection = styled(Box)(() => ({
  display: "flex",
  flexDirection: "row",
}));

export const DisplayFlexColumnDirection = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const DisplayFlexJustifyStart = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-start",
}));

export const DisplayFlexJustifyFlexEnd = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
}));

export const DisplayFlexJustifySpaceBetween = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
}));

export const DisplayRowSpaceBetween = styled(Box)(() => ({
  display:"flex",
  flexDirection:"row",
  justifyContent: "space-between"
}));

export const DisplayBoxFlexStart = styled(Box)(() => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
}));

export const DisplayFlexJustifyAlign = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}));

export const DisplayFlexStartCenterGrid = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
}));

export const DisplayFlexJustifySpaceAround = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-around",
}));

export const DisplayFlexAlignSpaceBetween = styled(Box)(() => ({
  display: "flex",
  alignContent: "space-between",
}));

export const DisplayFlexCenterGrid = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
}));

export const DisplayFlexAlignCenterGrid = styled(Grid)(() => ({
  display: "flex",
  justifyContent: "center",
}));

export const DisplayJustifyLeft = styled(Box)(() => ({
  display: "flex",
  justifyContent: "left",
  flexDirection: "column",
}));

export const DisplayJustifyRight = styled(Box)(() => ({
  display: "flex",
  justifyContent: "right",
}));

export const DisplayFlexWrap = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
}));

export const HeightandWidth = styled(Box)(() => ({
  width: "100%",
  height: "100%",
}));
/* common dispaly flex style end */

export const MarginAuto = styled(Box)(() => ({
  margin:"auto"
}));

export const DialogOpen = styled(Dialog)`
  & .MuiPaper-root.MuiPaper-elevation {
    overflow: visible;
  }
`;

export const EventPagination = styled(Pagination)`
  & .MuiPaginationItem-previousNext {
    background: #ddefff;
    color: #0062fd;
    height: 3.6vh;
    width: 1.4vw;
    border-radius: 3.2vh;
    // border: 1px solid red;
  }
  ,
  .MuiPaginationItem-root.Mui-selected {
    background: #3087ec;
    :hover {
      background: #3087ec;
    }
  }
  ,
  .MuiPaginationItem-page {
    background: red;
    display: none;
  }
`;

/* common dialog style start */
export const CloseAlertMainTitle = styled(Typography)(() => ({
  textAlign: "left",
  letterspacing: "0px",
  color: "#FF5A5A",
  opacity: 1,
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "16px",
}));

export const MainSubTitle = styled(Typography)(() => ({
  textAlign: "left",
  letterspacing: "0px",
  color: "#686868",
  opacity: 1,
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
}));

export const CloseAlertSubTitle = styled(Typography)(() => ({
  textAlign: "left",
  fontFamily: "poppins",
  letterSpacing: "0px",
  opacity: 1,
  fontWeight: 400,
  fontSize: "12px",
  color: "#FF5A5A",
  marginTop: "6px",
  marginBottom: "6px",
}));

export const CloseAlertButtons = styled(Button)(() => ({
  fontFamily: "poppins",
  letterSpacing: "0px",
  color: "#FFFFFF",
  fontSize: "14px",
  fontWeight: 500,
}));

/* common dialog style end */
export const WaitingButton = styled(Button)(() => ({
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: "500",
  fontSize: "14px",
  color: "#ffffff",
  borderRadius: "4px",
  //   "&hover": {
  //     background: "grey",
  //     color: "red",
  //   },
}));

export const LinkText = styled(Link)(() => ({
  textDecoration: "none",
  color: "#3087EC",
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "14px",
}));

export const ButtonAllocate = styled(Button)`
  width: 88px;
  height: 40px;
  background: #3087ec;
  border-radius: 4px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #ffffff;
  margin-right: 2vh;

  :hover {
    background: #3087ec;
    color: #ffffff;
  }
`;

export const TotalInstancesButton = styled(Button)`
  width: 167px;
  height: 40px;
  background: #ddffde;
  border-radius: 4px;
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #11bd60;
  margin-left: 2vh;

  :hover {
    background: #ddffde;
    color: #11bd60;
  }
`;

export const ContentWrapper = styled(Box)(
  () =>
    `
    // width:100%;
    // height:100%;
    overflow:auto;
    padding:0px;
    ::-webkit-scrollbar-thumb {
      background-color: rgba(155, 155, 155, 0.5);
      border-radius: 20px;
      border: transparent;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar {
       width: 3px;
    }
    `
);

export const CreateGroupBtn = styled(Button)(() => ({
  p: 0,
  background: "#DDEFFF",
  borderRadius: "4px",
  border: "none",
  height: "32px",
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "12px",
  color: "#0062FD",
  display: "flex",
}));

export const UpgradeGroupBtn = styled(Button)(() => ({
  marginRight: ".8rem",
  fontFamily: "Poppins",
  fontStyle: "normal",
  fontWeight: 500,
  fontSize: "0.8vw",
  background: "#F4EAFF",
  borderRadius: "0.4vh",
  color: " #5700C9",
  width: "6vw",
  height: "4vh",
}));

export const AppbarTitle = styled(Typography)(() => ({
  flex: 1,
  color: '#FFF',
  fontSize: '15px',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '20px',
  paddingLeft: 0,
}));

export const ActionMenuItem = {
  margin: "4px",
  fontSize: '13px',
  borderRadius: "4px",
  "&:hover": {
    color: "#fff",
    background: "#3087ec",
  }
};

export const propertyHeading = {
  fontSize: "13px",
  fontWeight: '550'
};

export const propertySubHeading = {
  fontSize: "12px",
  fontWeight: '400',
};
export const borderBox = {
  margin: '2px',
  border: '1px solid #fff',
  padding: '0px 3px',
  display: 'flex',
  alignItems: 'center',
  "&:hover": {
    border: '1px solid #d9d9d9',
    margin: '2px',
    padding: '0px 3px',
  }
};
